<ds-card class="d-flex flex-column card">
  <div class="d-flex justify-content-between p-4 p-md-6 pb-md-0 head">
    <div class="d-flex flex-column">
      <div class="d-flex align-items-center nowrap flex-wrap">
        @let fromAirport =
          flightOption.outbound.departure_airport.code | getAirportByLocationCode | async;
        <h3 class="semi-bold d-md-none" data-id="from">{{ fromAirport?.cityName }}</h3>
        <h2 class="semi-bold d-none d-md-inline" data-id="from">{{ fromAirport?.cityName }}</h2>

        @let src =
          flightOption.is_round_trip
            ? 'assets/icons/sync_alt.svg'
            : 'assets/icons/arrow_right_alt.svg';

        <img [src]="src" alt="sync" width="20" height="20" class="mx-2" />

        @let toAirport =
          flightOption.outbound.arrival_airport.code | getAirportByLocationCode | async;
        <h3 class="semi-bold d-md-none" data-id="to">{{ toAirport?.cityName }}</h3>
        <h2 class="semi-bold d-none d-md-inline" data-id="to">{{ toAirport?.cityName }}</h2>
      </div>

      @let outboundTime = flightOption.outbound.departure_airport.time | date: 'MMM d';
      @let inboundTime = flightOption.inbound?.arrival_airport?.time | date: 'MMM d';

      <div class="d-flex align-items-center nowrap flex-wrap">
        <p data-id="dates">
          {{ outboundTime }}
          @if (flightOption.is_round_trip) {
            – {{ inboundTime }}
          }
        </p>

        <ds-dot-separator class="mx-2" />

        @let passengerCount = passengerCountOverride ?? portalLead?.firstTrip?.passengerCount;
        @if (passengerCount) {
          <p [ngPlural]="passengerCount" data-id="pax">
            <ng-template ngPluralCase="=1">1 passenger</ng-template>
            <ng-template ngPluralCase="other">{{ passengerCount }} passengers</ng-template>
          </p>
        }
        @let travelClass = flightOption.travel_class || flightOption.travelClass;
        @let tripServiceClass = portalLead?.firstTrip?.serviceClass;
        @let serviceClass = tripServiceClass ? (tripServiceClass | label) : 'Business Class';
        @let travelClassLabel =
          travelClass === 'BUSINESS'
            ? 'Business Class'
            : travelClass === 'PREMIUM_ECONOMY'
              ? 'Premium Economy'
              : travelClass === 'MIXED'
                ? 'Mixed (PE + Business)'
                : serviceClass;

        <ds-dot-separator class="mx-2" />

        <p data-id="class">{{ travelClassLabel }}</p>
      </div>

      <div class="badge baseline mt-2" data-id="baseline">
        <p class="caption semi-bold">Baseline</p>
      </div>
    </div>

    @let price = flightOption.display_price | portalCurrency;
    <div class="d-flex flex-column pl-8">
      <h3 class="semi-bold d-md-none ml-auto" data-id="price">{{ price }}</h3>
      <h2 class="semi-bold d-none d-md-inline ml-auto" data-id="price">{{ price }}</h2>

      <p class="nowrap">Per passenger</p>
    </div>
  </div>

  <div class="d-flex flex-column px-4 px-md-6">
    <div class="d-flex flex-column mt-4 mt-md-6">
      <div class="d-flex align-items-center justify-content-between">
        <p class="semi-bold w-40" data-id="outbound-departure-airport">
          {{ flightOption.outbound.departure_airport.code }}
        </p>

        <div class="mx-4 separator"></div>

        @let nonstop = flightOption.outbound.stops === 0;
        <div [class.nonstop]="nonstop" class="d-flex flex-column badge duration nowrap">
          <p class="semi-bold" data-id="outbound-duration">
            {{ flightOption.outbound.duration | duration }}
            @if (nonstop) {
              <ds-dot-separator class="mx-2" />
              Nonstop
            }
          </p>
        </div>

        <div class="mx-4 separator"></div>

        <p class="semi-bold w-40 text-align-end" data-id="outbound-arrival-airport">
          {{ flightOption.outbound.arrival_airport.code }}
        </p>
      </div>

      <div class="d-flex align-items-center justify-content-between mt-1">
        <div class="d-flex align-items-center">
          <p class="caption">{{ flightOption.outbound.departure_airport.time | date: 'MMM d' }}</p>

          <ds-dot-separator class="mx-2" />

          <p class="caption">
            {{ flightOption.outbound.departure_airport.time | date: 'hh:mma' | lowercase }}
          </p>
        </div>

        <p class="caption">{{ flightOption.outbound.stop_info }}</p>

        <div class="d-flex align-items-center">
          @let daysShift =
            flightOption.outbound.arrival_airport.time.split(' ')[0] !==
            flightOption.outbound.departure_airport.time.split(' ')[0];

          <p [class.text-sun-crete-800]="daysShift" class="caption">
            {{ flightOption.outbound.arrival_airport.time | date: 'MMM d' }}
          </p>

          <ds-dot-separator class="mx-2" />

          <p class="caption">
            {{ flightOption.outbound.arrival_airport.time | date: 'hh:mma' | lowercase }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="flightOption.inbound" class="d-flex flex-column px-4 px-md-6">
    <div class="d-flex flex-column mt-4 mt-md-6">
      <div class="d-flex align-items-center justify-content-between">
        <p class="semi-bold w-40" data-id="inbound-departure-airport">
          {{ flightOption.inbound.departure_airport.code }}
        </p>

        <div class="mx-4 separator"></div>

        @let nonstop = flightOption.inbound.stops === 0;
        <div [class.nonstop]="nonstop" class="d-flex flex-column badge duration nowrap">
          <p class="semi-bold" data-id="inbound-duration">
            {{ flightOption.inbound.duration | duration }}
            @if (nonstop) {
              <ds-dot-separator class="mx-2" />
              Nonstop
            }
          </p>
        </div>

        <div class="mx-4 separator"></div>

        <p class="semi-bold w-40 text-align-end" data-id="inbound-arrival-airport">
          {{ flightOption.inbound.arrival_airport.code }}
        </p>
      </div>

      <div class="d-flex align-items-center justify-content-between mt-1">
        <div class="d-flex align-items-center">
          <p class="caption">{{ flightOption.inbound.departure_airport.time | date: 'MMM d' }}</p>

          <ds-dot-separator class="mx-2" />

          <p class="caption">
            {{ flightOption.inbound.departure_airport.time | date: 'hh:mma' | lowercase }}
          </p>
        </div>

        <p class="caption">{{ flightOption.inbound.stop_info }}</p>

        <div class="d-flex align-items-center">
          @let daysShift =
            flightOption.inbound.arrival_airport.time.split(' ')[0] !==
            flightOption.inbound.departure_airport.time.split(' ')[0];

          <p [class.text-sun-crete-800]="daysShift" class="caption">
            {{ flightOption.inbound.arrival_airport.time | date: 'MMM d' }}
          </p>

          <ds-dot-separator class="mx-2" />

          <p class="caption">
            {{ flightOption.inbound.arrival_airport.time | date: 'hh:mma' | lowercase }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div
    class="d-flex align-items-center justify-content-between gap-2 p-4 p-md-6 mt-4 mt-md-6 footer-row"
  >
    <div class="d-flex align-items-center min-w-0">
      @for (logo of flightOption.airline_logos; track logo) {
        <div class="d-flex align-items-center justify-content-center logo-container">
          <img [src]="logo" alt="logo" class="logo" />
        </div>
      }

      <p class="ml-2 text-truncate" data-id="airlines">{{ flightOption.airlines.join(', ') }}</p>
    </div>

    @if (showQuoteFeedback()) {
      @let liked = resolvedFeedback() === AutoQuoteOptionFeedbackEnum.LIKED;
      @let disliked = resolvedFeedback() === AutoQuoteOptionFeedbackEnum.DISLIKED;
      @let busy = submittingFeedback();

      <div class="d-flex align-items-center g-1 p-relative">
        @if (feedbackCoachmarkVisible()) {
          <div class="d-flex align-items-center g-2 px-4 py-3 nowrap popup">
            <img src="assets/icons/thumbs.svg" alt="thumbs" width="32" height="32" />
            <p>Tap to share your feedback</p>
            <div class="arrow"></div>
          </div>
        }

        <button
          class="thumbs-button"
          data-id="like"
          [disabled]="busy"
          (click)="submitOptionFeedback(AutoQuoteOptionFeedbackEnum.LIKED)"
        >
          @let thumbsupIcon =
            liked ? 'assets/icons/hand_thumbsup_green.svg' : 'assets/icons/hand_thumbsup.svg';

          <img [src]="thumbsupIcon" alt="thumbsup" width="32" height="32" />
        </button>

        <button
          class="thumbs-button"
          data-id="dislike"
          [disabled]="busy"
          (click)="submitOptionFeedback(AutoQuoteOptionFeedbackEnum.DISLIKED)"
        >
          @let thumbsdownIcon =
            disliked ? 'assets/icons/hand_thumbsdown_red.svg' : 'assets/icons/hand_thumbsdown.svg';

          <img [src]="thumbsdownIcon" alt="thumbsdown" width="32" height="32" />
        </button>
      </div>
    }
  </div>
</ds-card>
